export default function getOneOnOneHistoryPath(requesterId, requestedId) {
  return `/1-on-1/${requestedId}/${requesterId}/history`;
}
